<template>
    <div class="conter">
        <div class="currency_suggest">
            <div class="titel" v-if="reporInfo.third_img != null">
                <span>三维施工图</span>
            </div>
            <!-- @click="goSanwei" -->
            <!-- @click="goSanwei(reporInfo.third_img)" -->
            <div v-if="reporInfo.third_img != null" class="tips_img" @click="goSanwei(reporInfo.third_img)">
                <!-- <img src="@/assets/images/antV2/scheme/sanwei_icon.png" alt="" /> -->
                <img :src="reporInfo.third_img_url" alt="" />
                <!-- <div class="lookImg">点击查看原理图</div> -->
                <!-- <div class="lookCode">
          <img :src="reporInfo.third_img_code" alt="">
        </div> -->
            </div>
            <div class="titel">
                <span>系统设计图</span>
            </div>
            <div class="deploy-banner">
                <swiper class="slide" :options="swiperOption" ref="mySwiper">
                    <swiper-slide v-for="(switem, swindex) in reporInfo.goods_album" :key="swindex" class="slide-list">
                        <div class="drang-lab" v-if="switem.imgname != ''">
                            {{ switem.imgname }}
                        </div>
                        <img :src="switem.img" alt="" preview="1" />
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
            </div>
        </div>
        <!-- 图片查看 -->
        <!-- 预览图片 -->
        <div class="swiperimg" v-show="showSwiper">
            <div class="preview-img">
                <swiper :options="swiperOptiontwo" ref="mySwiper">
                    <swiper-slide v-for="item in reporInfo.goods_album" :key="item.id">
                        <div class="swiper-zoom-container">
                            <img :src="item.img" alt />
                        </div>
                    </swiper-slide>
                    <!--<div class="swiper-pagination "  slot="pagination"></div>-->
                </swiper>
            </div>
            <div v-show="showSwiper" class="close-preview" @click="showSwiper = false">
                关闭预览
            </div>
        </div>
        <div class="currency_suggest" ref="contrast">
            <div class="titel">
                <span>系统对比</span>
            </div>
            <div class="balancesuggest">
                <div :class="['left-item']">
                    <div class="shopptitle tpis">冷暖风水专业集成系统</div>
                    <div class="shopptext tpis">
                        {{
                            arrContrastLaber[nducat].arrText[nCuiltips].newName
                        }}
                    </div>
                </div>
                <div class="tips">vs</div>
                <div :class="[
                        'left-item',
                        nCuiltips == arrContrastLaber[nCuiltips].id
                            ? 'tpi'
                            : '',
                    ]">
                    <div class="shopptitle" @click="bLaber = !bLaber">
                        {{ arrContrastLaber[nducat].arrTitle[nCuiltips].name }}
                        <div class="tips-list" v-if="bLaber">
                            <div @click="getTips(index, item.id, nducat)" v-for="(item, index) in arrContrastLaber[nducat]
                                    .arrTitle" :key="index" :class="[nCuiltips == index ? 'actColor' : '']">
                                <!-- v-show="nducat != 0 ? index != 0 : ''" -->
                                {{ item.name }}
                            </div>
                        </div>
                    </div>
                    <div class="shopptext">
                        {{ arrContrastLaber[nducat].arrText[nCuiltips].name }}
                    </div>
                </div>
            </div>
            <!-- startamin   加上class开启序列中动画 -->
            <div class="anmin">
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" v-show="nducat == 2" :class="[
                        arrContrastLaber[nCuiltips].arrAnimClass[nducat]
                            .animClass,
                    ]">
                    <image :class="[nducat == 2 && bSubtop ? 'startamin' : '']" :xlink:href="
                            arrContrastLaber[nducat == 2 ? nCuilId : nCuiltips]
                                .arrAnimClass[nducat].imgSrc
                        " alt=""></image>
                </svg>
                <!-- nducat == 1 && bSubtop ? 'startteveamin' : '', -->
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" v-show="nducat == 1 || nducat == 0" v-for="(item, index) in arrContrastLaber[nCuiltips]
                        .arrAnimClass[nducat].arrFixedClass" :key="index" :class="[item.animNeiClass]">
                    <!-- <svg class="trastimg-two-left"> -->
                    <!-- startHotamin -->
                    <image :class="[
                            (nducat == 1 || nducat == 0) && bSubtop
                                ? 'startteveamin'
                                : '',
                        ]" :xlink:href="item.imgSrc" alt=""></image>
                    <!-- </svg> -->
                </svg>
                <!-- 动画图片 -->
            </div>
            <div class="point">
                *在室外低温-10℃左右状态下，室内超过26℃即算作高温模式。
            </div>
            <div class="warp-list">
                <div v-for="(item, index) in arrContrastLaber" :key="index" :class="[
                        item.oBright.className,
                        nducat == index ? 'click-ducat' : '',
                        nducat == index ? 'no' + item.oBright.className : '',
                    ]" @click="getEducation(index)">
                    {{ item.oBright.name }}
                </div>
            </div>
        </div>
        <div class="currency_suggest">
            <div class="titel">
                <span>VR场景</span>
            </div>
            <div class="vr-img">
                <swiper :options="swiperOptionvr" v-if="arrVrList.length" ref="mySwipervr">
                    <swiper-slide v-for="(item, index) in arrVrList" :key="index">
                        <img :src="item.img" :alt="item.name" @click="goVr(item.url)" />
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
            </div>
        </div>
        <!-- 系统报价 -->
        <!-- 暂时废弃  reporInfo.show_amount != 0 !objOffer.arrInfo.length展示 -->
        <div class="currency_suggest" v-if="!objOffer.arrInfo.length">
            <div class="titel">
                <span>项目配置清单</span>
            </div>
            <!-- 套餐报价 reporInfo.show_amount == 2-->
            <div class="piceTaocan">
                <div class="conter_pice">
                    <div class="setmeal_shopp" v-for="(item, index) in reporInfo.product" :key="index" @click="getDetails(item.product_id)" v-show="reporInfo.product.length">
                        <div class="setmeal_shopp_list">
                            <div class="shopp_item shopp_two">
                                <img class="" v-lazy="item.mobile_img" alt="" />
                            </div>
                            <div class="shopp_item shopp_three">
                                <div class="type_name">
                                    {{ item.new_goods_type_name }}
                                </div>
                                <div>
                                    {{ item.goods_name }}
                                </div>
                                <div class="attr_label" v-for="(sumitem, sumindex) in item.attr_two" :key="sumindex">
                                    <div>{{ sumitem.attr_name }}</div>
                                    :
                                    <div>{{ sumitem.attr_value }}</div>
                                </div>
                            </div>
                            <div class="shopp_item shopp_four">
                                {{ item.num }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="money" v-if="reporInfo.show_amount != 0">
                    套餐价格：￥{{ reporInfo.report_amount }}
                </div>
            </div>
        </div>
        <!-- objOffer.arrInfo.length -->
        <div class="currency_suggest" v-if="objOffer.arrInfo.length">
            <div class="titel">
                <span>项目配置清单</span>
            </div>
            <div class="list_item" v-for="(item, index) in objOffer.arrInfo" :key="index">
                <div v-show="item.goods.length">
                    <div class="list_header">
                        <div class="min_title">
                            {{
                                "Step" +
                                (index + 1) +
                                ":" +
                                item.info.type_group_name
                            }}
                        </div>
                    </div>
                    <div class="tabel_title">
                        <div class="tabel_title_item" :style="
                                objOffer.order.show_amount == 0
                                    ? 'width:40%;'
                                    : ''
                            ">
                            名称
                        </div>
                        <div class="tabel_title_item" :style="
                                objOffer.order.show_amount == 0
                                    ? 'width:40%;'
                                    : ''
                            ">
                            规格型号
                        </div>
                        <div class="tabel_title_item" v-if="objOffer.order.show_amount != 0">
                            单价
                        </div>
                        <div class="tabel_title_item" :style="
                                objOffer.order.show_amount == 0
                                    ? 'width:20%;'
                                    : ''
                            ">
                            数量
                        </div>
                    </div>
                    <div class="tabel_content">
                        <div class="tabel_content_list" v-for="(sumitem, sumindex) in item.goods" :key="sumindex">
                            <div class="tabel_content_item" :style="
                                    objOffer.order.show_amount == 0
                                        ? 'width:40%;'
                                        : ''
                                ">
                                {{ sumitem.name }}
                            </div>
                            <div class="tabel_content_item" :style="
                                    objOffer.order.show_amount == 0
                                        ? 'width:40%;'
                                        : ''
                                ">
                                {{ sumitem.code }}
                            </div>
                            <div class="tabel_content_item" v-if="objOffer.order.show_amount != 0">
                                <div class="tabel_input" :style="
                                        objOffer.order.show_amount == 0
                                            ? 'width:20%;'
                                            : ''
                                    ">
                                    {{ sumitem.amount }}
                                </div>
                            </div>
                            <div class="tabel_content_item">
                                <div class="tabel_input">{{ sumitem.num }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="subtotal" v-if="objOffer.order.show_amount != 0">
                        <div>小计:</div>
                        <div>
                            {{
                                Number(item.info.total_amount).toFixed(2) + "元"
                            }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="total" v-if="objOffer.order.show_amount != 0">
                <div>总计:</div>
                <div>
                    {{ Number(objOffer.order.order_amount).toFixed(2) + "元" }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        objOffer: {
            type: Object,
            default: function () {
                return {};
            },
        },
        nCuiltips: {
            type: Number,
            default: function () {
                return 0;
            },
        },
        arrVrList: {
            type: Array,
            default: false,
        },
        reporInfo: {
            type: Object,
            default: false,
        },
    },
    data() {
        const vm = this;
        return {
            showSwiper: false,
            arrErnav: [{ title: "系统报价" }, { title: "套餐报价" }],
            arrClass: [
                { leftClass: "letfone" },
                // { leftClass: "letftwo" },
                { leftClass: "letfthree" },
                // { leftClass: "letffour" },
            ],
            arrTabelNav: [
                { room_type: "项目" },
                { room_type: "型号/规格" },
                { room_type: "单价" },
                { room_type: "数量" },
            ],
            secondIndex: 0,
            nducat: 0,
            //当滚到一定距离开启动画
            bSubtop: false,
            //系统对比提示框
            bLaber: false,
            //系统对比
            arrContrastLaber: [
                {
                    id: 0,
                    arrTitle: [
                        { name: "中央空调", id: 0 },
                        { name: "燃气地暖系统", id: 1 },
                        { name: "户式水机两联供", id: 2 },
                    ],
                    oBright: { name: "制热效果", className: "warp-one" },
                    arrText: [
                        {
                            name: "无法达到高温模式",
                            newName: "寒冷天气快速升至高温模式",
                        },
                        {
                            name: "升温缓慢",
                            newName: "寒冷天气快速升至高温模式",
                        },
                        {
                            name: "无法达到高温模式",
                            newName: "寒冷天气快速升至高温模式",
                        },
                    ],
                    arrAnimClass: [
                        {
                            arrFixedClass: [
                                {
                                    animNeiClass: "new_trastimg-one-left",
                                    imgSrc: require("@/assets/images/ant/speed/new_five.jpg"),
                                },
                                {
                                    animNeiClass: "new_trastimg-one-right",
                                    imgSrc: require("@/assets/images/ant/speed/new_six.jpg"),
                                },
                            ],
                        },
                        {
                            arrFixedClass: [
                                {
                                    animNeiClass: "trastimg-one-left",
                                    imgSrc: require("@/assets/images/ant/speed/speed-one.jpg"),
                                },
                                {
                                    animNeiClass: "trastimg-one-right",
                                    imgSrc: require("@/assets/images/ant/speed/speed-two.jpg"),
                                },
                            ],
                        },
                        {
                            animClass: "trastimg-three",
                            imgSrc: require("@/assets/images/ant/sprite/buying_four.png"),
                        },
                    ],
                },
                {
                    id: 1,
                    arrTitle: [
                        { name: "中央空调", id: 0 },
                        { name: "燃气地暖系统", id: 1 },
                        { name: "户式水机两联供", id: 2 },
                    ],
                    oBright: { name: "制热速度", className: "warp-two" },
                    arrText: [
                        {
                            name: "升温≈66分钟",
                            newName: "升温≈16分钟,快速制热,瞬间升温",
                        },
                        {
                            name: "升温≈831分钟",
                            newName: "升温≈16分钟,快速制热,瞬间升温",
                        },
                        {
                            name: "升温≈831分钟",
                            newName: "升温≈16分钟,快速制热,瞬间升温",
                        },
                    ],
                    arrAnimClass: [
                        {
                            arrFixedClass: [
                                {
                                    animNeiClass: "new_trastimg-one-left",
                                    imgSrc: require("@/assets/images/ant/speed/new_five.jpg"),
                                },
                                {
                                    animNeiClass: "new_trastimg-one-right",
                                    imgSrc: require("@/assets/images/ant/speed/new_seven.jpg"),
                                },
                            ],
                        },
                        {
                            arrFixedClass: [
                                {
                                    animNeiClass: "trastimg-one-left",
                                    imgSrc: require("@/assets/images/ant/speed/speed-one.jpg"),
                                },
                                {
                                    animNeiClass: "trastimg-two-right",
                                    imgSrc: require("@/assets/images/ant/speed/speed-three.jpg"),
                                },
                            ],
                        },
                        {
                            animClass: "trastimg-three",
                            imgSrc: require("@/assets/images/ant/sprite/buying_three.png"),
                        },
                    ],
                },
                {
                    id: 2,
                    arrTitle: [
                        { name: "燃气地暖系统", id: 1 },
                        { name: "户式水机两联供", id: 2 },
                    ],
                    oBright: { name: "节能效率", className: "warp-three" },
                    arrText: [
                        { name: "", newName: "节能≈40%" },
                        { name: "", newName: "节能≈ 14%" },
                    ],
                    arrAnimClass: [
                        {
                            arrFixedClass: [
                                {
                                    animNeiClass: "new_trastimg-one-left",
                                    imgSrc: require("@/assets/images/ant/speed/new_five.jpg"),
                                },
                                {
                                    animNeiClass: "new_trastimg-one-right",
                                    imgSrc: require("@/assets/images/ant/speed/new_eight.jpg"),
                                },
                            ],
                        },
                        {
                            arrFixedClass: [
                                {
                                    animNeiClass: "trastimg-one-left",
                                    imgSrc: require("@/assets/images/ant/speed/speed-one.jpg"),
                                },
                                {
                                    animNeiClass: "trastimg-three-right",
                                    imgSrc: require("@/assets/images/ant/speed/speed-four.jpg"),
                                },
                            ],
                        },
                        {
                            animClass: "trastimg-three",
                            imgSrc: require("@/assets/images/ant/sprite/buying_four.png"),
                        },
                    ],
                },
            ],
            //轮播图配置
            swiperOption: {
                speed: 200,
                spaceBetween: 0,
                slidesPerView: 1,
                centeredSlides: true,
                loop: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true, // 允许点击小圆点跳转
                },
                on: {
                    slideChangeTransitionEnd() {
                        vm.headIndex = this.activeIndex;
                    },
                },
            },
            swiperOptiontwo: {
                clickable: true,
                noSwiping: true,
                zoom: true,
                on: {
                    slideChangeTransitionStart: function (swiper) {
                        // this.swiperIndex = this.swiper.activeIndex;
                    }.bind(this),
                },
            },
            swiperOptionvr: {
                speed: 200,
                spaceBetween: 0,
                slidesPerView: 1,
                centeredSlides: true,
                loop: true,
                pagination: {
                    el: ".swiper-pagination",
                    // clickable: true, // 允许点击小圆点跳转
                },
                on: {
                    slideChangeTransitionEnd() {
                        vm.headIndex = this.activeIndex;
                    },
                },
            },
        };
    },
    filters: {
        roomNumber(index) {
            let arr = [
                "一",
                "二",
                "三",
                "四",
                "五",
                "六",
                "七",
                "八",
                "九",
                "十",
            ];
            if (index < 0) {
                return "地下室" + arr[Number(-index) - 1] + "层";
            } else if (index <= 10 && index > 0) {
                return arr[Number(index) - 1] + "层";
            }
        },
    },
    computed: {
        // 轮播实例对象
        swiper() {
            return this.$refs.mySwiper.swiper;
        },
        swipervr() {
            return this.$refs.mySwipervr.swiper;
        },
    },
    mounted() {
        window.addEventListener("scroll", this.windowScroll); //监听页面滚动
    },
    destroyed() {
        window.removeEventListener("scroll", this.windowScroll); //销毁滚动事件
    },
    methods: {
        //查看商品详情
        getDetails(id) {
            this.$router.push({ path: `/shopp/details?id=${id}` });
        },
        //查看图片
        //图片查看器
        lookImg(index) {
            this.showSwiper = true;
            this.swiper.slideTo(index, 1000, true);
        },
        goSanwei(url) {
            window.location.href = url;
        },
        //点击二级导航
        getAtcStr(index) {
            this.secondIndex = index;
        },
        goVr(item) {
            window.location.href = item;
        },
        //页面滚动,导航切换显示
        windowScroll() {
            this.getTopAnmin();
        },
        //点击功能对比选项卡
        getEducation(index) {
            if (index == 2) {
                this.nCuiltips = 0;
                this.nCuilId = 1;
            } else {
            }
            this.nducat = index;
            this.bSubtop = false;
            this.bLaber = false;
            setTimeout(() => {
                this.getTopAnmin();
            }, 300);
        },
        //监听元素与顶部的距离，开启动画
        getTopAnmin() {
            let subTop = this.$refs.contrast.getBoundingClientRect().top;
            if (subTop < 200) {
                if (this.nducat == 2 || this.nducat == 1 || this.nducat == 0) {
                    this.bSubtop = true;
                }
            } else {
                this.bSubtop = false;
            }
        },
        //点击系统对比选项卡
        getTips(index, id, nducatIndex) {
            this.bSubtop = false;
            this.nCuilId = id;
            this.nCuiltips = index;
            setTimeout(() => {
                this.getTopAnmin();
            }, 200);
        },
    },
};
</script>
<style lang="scss" scoped>
@import "index.scss";
</style>